<template>
   <a-input-number
     style="font-size: 12px"
     :precision="precision"
     :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
     :parser="value => value.replace(/\$\s?|(,*)/g, '')" v-model="inputValue"  v-bind="$attrs"  @change="changeValue"
     @blur="blurValue"
     :class="blackhillsYellow ? 'blackhillsYellow' : ''">
   </a-input-number>
</template>

<script>
  export default {
    name: 'ptInputNumber',
    props:{
      value:{
        type: [Number, String] ,
      },
      precision:{
        type:Number,
        default:2,
      },
      blackhillsYellow:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        inputValue:this.value,
      }
    },
    watch:{
      value (val) {
        if(typeof val == 'string'){
          this.inputValue = val.replace(/\$\s?|(,*)/g, '')
        }else{
          this.inputValue = val
        }
      },
      inputValue(newValue){
        this.$emit('input',newValue)
      },
    },
    mounted() {
      if(typeof this.value == 'string'){
        this.inputValue = this.value.replace(/\$\s?|(,*)/g, '')
      }else{
        this.inputValue = this.value
      }
    },
    methods: {
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value)
      },
      blurValue(event) {
        this.$emit('blur', event)
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";
  .blackhillsYellow{
    /deep/ input{
      font-size: 12px;
      color: @blackhills-yellow;
    }
  }
</style>
